import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocalizedPath } from '../../hooks/useLocalizedPath';
import styles from './StatusWidget.module.css';

const services = [
  { nameKey: 'status.services.website', status: 'operational' },
  { nameKey: 'status.services.catalog', status: 'operational' },
  { nameKey: 'status.services.orders', status: 'operational' },
  { nameKey: 'status.services.logistics', status: 'operational' },
  { nameKey: 'status.services.support', status: 'operational' },
] as const;

export function StatusWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation('common');
  const { lp } = useLocalizedPath();

  if (location.pathname === '/status' || location.pathname === '/en/status') return null;

  return (
    <div className={styles.wrapper}>
      {isOpen && (
        <div className={styles.popup}>
          <div className={styles.popupHeader}>
            <span className={styles.popupTitle}>{t('status.title')}</span>
            <button
              className={styles.closeButton}
              onClick={() => setIsOpen(false)}
              aria-label={t('aria.close')}
            >
              ×
            </button>
          </div>
          <ul className={styles.serviceList}>
            {services.map((s) => (
              <li key={s.nameKey} className={styles.serviceItem}>
                <span className={`${styles.dot} ${styles[s.status]}`} />
                <span className={styles.serviceName}>{t(s.nameKey)}</span>
                <span className={`${styles.serviceStatus} ${styles[s.status]}`}>
                  {t(`status.labels.${s.status}`)}
                </span>
              </li>
            ))}
          </ul>
          <Link
            to={lp('/status')}
            className={styles.detailsLink}
            onClick={() => setIsOpen(false)}
          >
            {t('status.viewDetails')}
          </Link>
        </div>
      )}
      <button
        className={styles.trigger}
        onClick={() => setIsOpen(!isOpen)}
        aria-label={t('status.title')}
      >
        <span className={styles.triggerDot} />
      </button>
    </div>
  );
}
